import React, { createContext, useState } from 'react';
import { User } from '../../models';

type UserState = {
  user?: User;
  setUser: React.Dispatch<React.SetStateAction<User | undefined>>;
};

const defaultMeState: UserState = {
  user: undefined,
  setUser: () => {},
};

export const UserContext = createContext(defaultMeState);

export const UserContextProvider = (props: any) => {
  const [user, setUser] = useState(defaultMeState.user);

  return <UserContext.Provider value={{ user, setUser }}>{props.children}</UserContext.Provider>;
};
